/* eslint-disable */
// this is an auto generated file. This will be overwritten
export const listClients = `query ListClients(
  $filter: ModelClientFilterInput
  $limit: Int
  $nextToken: String
) {
  listClients(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      code
      name
      description
      logo
      website
      email
      address
      phoneno
      accounts {
        nextToken
      }
      features {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdated
      version
    }
    nextToken
  }
}
`;

// Stream Router Interface Queries
export const listStreamRouterInterfacesConnections = `query ListStreamRouterInterfacesConnections($streamRouterId: String!) {
  listStreamRouterInterfacesConnections(streamRouterId: $streamRouterId) {
    success
    message
    dataJson
  }
}
`;

export const getStreamRouterInterfaceConnections = `query GetStreamRouterInterfaceConnections($streamRouterId: String!, $interfaceId: String!) {
  getStreamRouterInterfaceConnections(streamRouterId: $streamRouterId, interfaceId: $interfaceId) {
    success
    message
    dataJson
  }
}
`;

export const listStreamRouterInterfaces = `query ListStreamRouterInterfaces($streamRouterId: String!) {
  listStreamRouterInterfaces(streamRouterId: $streamRouterId) {
    success
    message
    dataJson
  }
}
`;

export const getStreamRouterInterface = `query GetStreamRouterInterface($streamRouterId: String!, $interfaceId: String!) {
  getStreamRouterInterface(streamRouterId: $streamRouterId, interfaceId: $interfaceId) {
    success
    message
    dataJson
  }
}
`;

export const getStreamRouterInterfaceStatus = `query GetStreamRouterInterfaceStatus($streamRouterId: String!, $interfaceId: String!) {
  getStreamRouterInterfaceStatus(streamRouterId: $streamRouterId, interfaceId: $interfaceId) {
    success
    message
    dataJson
  }
}
`;

// Wowza Queries
export const listWowzaApplications = `query ListWowzaApplications($serverId: String!) {
  listWowzaApplications(serverId: $serverId) {
    success
    message
    dataJson
  }
}
`;

export const getWowzaApplication = `query GetWowzaApplication($serverId: String!, $applicationId: String!) {
  getWowzaApplication(serverId: $serverId, applicationId: $applicationId) {
    success
    message
    dataJson
  }
}
`;

export const listWowzaAppTargets = `query ListWowzaAppTargets($serverId: String!, $applicationId: String!) {
  listWowzaAppTargets(serverId: $serverId, applicationId: $applicationId) {
    success
    message
    dataJson
  }
}
`;

export const getWowzaAppTarget = `query GetWowzaAppTarget($serverId: String!, $applicationId: String!, $targetId: String!) {
  getWowzaAppTarget(serverId: $serverId, applicationId: $applicationId, targetId: $targetId) {
    success
    message
    dataJson
  }
}
`;

export const sourceMonitoringEventsByStartTime = `query SourceMonitoringEventsByStartTime(
  $startTime: String!
  $endTime: String!
  $limit: Int
  $nextToken: String
) {
  eventsByStartTime(
    type: OU
    startTime: { between: [$startTime, $endTime] }
    sortDirection: ASC
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      fixture
      sport
      property
      config
      tags
      requestedBitrate
      inputVideoPid
      inputAudioPid
      inputFrcEnabled
      lineupTime
      startTime
      endTime
      serviceStartTime
      serviceEndTime
      status
      customer {
        id
        name
      }
      account {
        id
        name
      }
      inputDetails
      inputDownlinkConfig {
        satelliteName
        satelliteFrequency
        satellitePolarization
        symbolRate
        BISS
        service
      }
      input {
        id
        name
        type
        status
      }
      inputOverride {
        id
        name
        type
        status
      }
      inputProfile {
        id
        name
        description
        location
        config
        supportedTypes
        provider {
          id
          name
          contactDetails
          instructions
        }
      }
      outputs(limit: 1500) {
        items {
          id
          outputOttApplicationOverride
          output {
            id
            name
            displayName
            outputType
            status
          }
        }
      }
      actions(limit: 1500) {
        items {
          id
          actionType
          config
          assignedOutput {
            id
          }
        }
      }
    }
    nextToken
  }
}
`;

export const getEventReportData = `query GetEventReportData(
  $eventId: ID!
  $startTime: AWSDateTime
  $endTime: AWSDateTime
  $customRegion: String
  $period: Int
) {
  getEventReportData(
    eventId: $eventId
    startTime: $startTime
    endTime: $endTime
    customRegion: $customRegion
    period: $period
  ) {
    success
    message
    dataJson
  }
}
`;

export const getEventAnalyticsReport = `query GetEventAnalyticsReport($id: ID!) {
  getEventAnalyticsReport(id: $id) {
    id
    eventId
    data
    createdAt
    updatedAt
  }
}
`;

export const listEventAnalyticsReportsByEventId = `query ListEventAnalyticsReportsByEventId(
  $filter: ModelEventAnalyticsReportFilterInput
  $limit: Int
) {
  listEventAnalyticsReports(filter: $filter, limit: $limit) {
    items {
      id
      eventId
      data
      createdAt
      updatedAt
    }
  }
}
`;

// Lightweight: only report meta (which events have a report + status/id).
// Full report payload (`data`) is fetched per report via getEventAnalyticsReport.
export const eventAnalyticsReportsBatch = `query EventAnalyticsReportsBatch($eventIds: [ID!]!) {
  eventAnalyticsReportsBatch(eventIds: $eventIds) {
    message
    success
    items {
      eventId
      generatedAt
      reportId
      status
    }
  }
}
`;
